import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgitatorDisc = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 135,
	viewBox: "0 0 80.0 135.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 40.0 0.0 L 40.0 120.0 M 20.0 120.0 L 60.0 120.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 105,
			width: 20,
			height: 30,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 60,
			y: 104.5,
			width: 20,
			height: 30,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgAgitatorDisc;
